import Components from './components';
export default {
    /**
     * 安装到Vue环境
     * @param {*} Vue
     * @param {*} options
     */
    install: (Vue, options) => {
        // 处理组件库
        for (let name of Object.keys(Components)) {
            Vue.component(Components[name]['name'], Components[name]);
        }
    }
};
